import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface ScheduledRateInfo {
  rate: number;
  start: Date;
  end: Date;
}

export interface ScheduledDifferentialInfo {
  differentialRate: number;
  start: Date;
  end: Date;
}

export interface ScopeRateInfo {
  normalRate: number;
  normalDiff: number;
  scheduledRates: ScheduledRateInfo[];
  scheduledDiffs: ScheduledDifferentialInfo[];
}

export type BillableRateCalculatorData = Record<
  ScopeOfPracticeEnum,
  ScopeRateInfo
>;

export interface ShiftRateCalculation {
  date: Date;
  scopeOfPractice: ScopeOfPracticeEnum;
  baseRate: number;
  differentialRate: number;
  totalRate: number;
  isBaseRateScheduled: boolean;
  isDifferentialScheduled: boolean;
}
